import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'

import _locator from '@/service-locator'

const modules = {
  app: require('./modules/app').default,
  errorLog: require('./modules/error-log').default,
  invoice: require('./modules/invoice').default,
  exports: require('./modules/exports').default,
  order: require('./modules/order').default,
  dispute: require('./modules/dispute').default,
  permission: require('./modules/permission').default,
  route: require('./modules/route').default,
  settings: require('./modules/settings').default,
  settlement: require('./modules/settlement').default,
  tagsView: require('./modules/tags-view').default,
  user: require('./modules/user').default,
  profile: require('./modules/profile').default,
  userProfile: require('./modules/user-profile').default,
  translations: require('./modules/translations').default,
  barcodeSettings: require('./modules/barcode-settings').default,
  webhooks: require('./modules/webhooks').default,
  transaction: require('./modules/transaction').default,
  dashboard: require('./modules/dashboard').default,
  store: require('./modules/store').default,
  api: require('./modules/api').default,
  rating: require('./modules/rating').default,
  kyc: require('./modules/kyc').default,
  onboarding: require('./modules/onboarding').default,
  address: require('./modules/address').default,
  ads: require('./modules/ads').default,
  globalSearch: require('./modules/global-search').default,
  configuration: require('./modules/configuration').default,
  chatbot: require('./modules/chatbot').default,
  farah: require('./modules/farah').default,
  iban: require('./modules/iban').default,
  branch: require('./modules/branch').default,
  instoreMaterialDelivery: require('./modules/instore-material-delivery')
    .default,
  merchantSupport: require('./modules/merchant-support').default,
  merchantKyc: require('./modules/merchant-kyc').default,
  dcs: require('./modules/dcs').default,
  businessLending: require('./modules/business-lending').default,
}

const buildRootStore = (locator) => {
  Vue.use(Vuex)

  const store = new Vuex.Store({
    modules,
    getters,
  })

  locator.store = store

  return store
}

export { buildRootStore }

// XXX backward compat, remove later on
export default _locator.store
